export default __webpack_public_path__ + "static/financial-insight-3f570f3d92723c086079fa5d0b6ea60c.webp";